import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Confirm from 'views/confirm/confirm'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'
import generalActions from 'redux/actions/generalActions'


const CONFIRM_TYPE = confirmTypes.STUDENT_NO_ACCOUNT_CONFIRM

const StudentNoAccountConfirm = props => (
	<Confirm
		btTwo={localize('student_accounts_sso_noAccountConfirm_button')}
		alertTitle={localize('student_accounts_sso_noAccountConfirm_title')}
		alertMessage={localize('student_accounts_sso_noAccountConfirm_subTitle')}
		actionTwo={() => props.actions.closeConfirm(CONFIRM_TYPE)}
		closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

StudentNoAccountConfirm.propTypes = {
	actions: PropTypes.shape({
		closeConfirm: PropTypes.func.isRequired,
	}).isRequired,
}

export default connect(null, mapDispatchToProps)(StudentNoAccountConfirm)

export {
	StudentNoAccountConfirm,
}
